<template>
  <div>
    <!-- team card -->
    <div class="ma-3">
      <v-row>
        <v-col
          cols="12"
          md="3"
          sm="6"
          v-for="(item, index) in lineTeams.teams"
          :key="index"
        >
          <v-card
            class="mx-auto"
            max-width="354"
            :min-height="$vuetify.breakpoint.smAndDown ? 150 : 140"
            shaped
            elevation="3"
          >
            <v-card-text>
              <div class="text-center pb-2 body-1">
                {{ item.City }} {{ item.Name }}
              </div>

              <v-row>
                <v-col cols="6" md="6" sm="6">
                  <v-avatar tile size="60" color="#ECEFF1">
                    <img :src="item.WikipediaLogoUrl" />
                  </v-avatar>
                </v-col>

                <v-col cols="6" md="6" sm="6" class="text-center">
                  <span
                    class="caption font-weight-bold ml-2 links"
                    @click.stop="getDepthChart(item.TeamID)"
                  >
                    Line Combos <br />
                  </span>
                  <span
                    class="caption font-weight-bold ml-2 links"
                    @click.stop="getDepthChart(item.TeamID)"
                  >
                    Power Play <br />
                  </span>
                  <span
                    class="caption font-weight-bold ml-2 links"
                    @click.stop="getDepthChart(item.TeamID)"
                  >
                    Defense <br />
                  </span>
                  <!-- <span
                    class="caption font-weight-bold ml-2 links"
                    @click.stop="getDepthChart(item.TeamID)"
                  >
                    All Goalies
                  </span> -->
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- dialog -->
        <v-dialog v-model="dialog" max-width="800">
          <v-card class="pa-2">
            <line-combination :depthChart="Arr" />
            <v-spacer></v-spacer>

            <v-card-actions>
              <v-btn color="red darken-1" text @click="dialog = false">
                close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- dialog ends -->
      </v-row>
    </div>
    <!-- team card -->
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import axios from "axios";
import lineCombination from "../../components/Lists/lineCombination.vue";
export default {
  name: "NhlLineComb",
  props: ["defaultSport"],
  components: {
    lineCombination,
  },

  data: () => ({
    dialog: false,
    Arr: {},
  }),

  created() {
    this.$store.dispatch("NhlModule/fetchLineCombination");
  },

  computed: {
    ...mapState("NhlModule", ["lineTeams", "depthChart"]),
    ...mapGetters("NhlModule", ["getGoalieLoader"]),
  },

  methods: {
    getDepthChart(teamId) {
      let obj = {
        TeamID: teamId,
        SportId: 3,
      };
      axios
        .post("https://api.fantasylineups.com/nhl/nhlgetTeamData", obj)
        .then((res) => {
          console.log(res.data);
          this.transformer(res.data);
        })
        .catch((err) => {
          console.error(err.message);
        });
      this.dialog = !this.dialog;
    },

    transformer(data) {
      let LWarr = [];
      let RWarr = [];
      let Carr = [];
      let PP1arr = [];
      let PP2arr = [];
      let LDarr = [];
      let RDarr = [];

      LWarr = data.players[0].EvenStrengthLines.filter((player) => {
        return player.Position == "LW";
      }).sort((a, b) => a.LineNumber - b.LineNumber);

      RWarr = data.players[0].EvenStrengthLines.filter((player) => {
        return player.Position == "RW";
      }).sort((a, b) => a.LineNumber - b.LineNumber);

      Carr = data.players[0].EvenStrengthLines.filter((player) => {
        return player.Position == "C";
      }).sort((a, b) => a.LineNumber - b.LineNumber);

      LDarr = data.players[0].EvenStrengthLines.filter((player) => {
        return player.Position == "LD";
      }).sort((a, b) => a.LineNumber - b.LineNumber);

      RDarr = data.players[0].EvenStrengthLines.filter((player) => {
        return player.Position == "RD";
      }).sort((a, b) => a.LineNumber - b.LineNumber);

      PP1arr = data.players[0].PowerPlayLines.filter((player) => {
        return player.LineNumber == 1;
      });

      PP2arr = data.players[0].PowerPlayLines.filter((player) => {
        return player.LineNumber == 2;
      });

      this.Arr = {
        LWarr,
        RWarr,
        Carr,
        LDarr,
        RDarr,
        PP1arr,
        PP2arr,
        FullName: data.players[0].FullName,
        Jersey_Image: data.players[1].Jersy_Image,
        Key: data.players[0].Key,
        TeamID: data.players[0].TeamId,
      };

      console.log("Arr", this.Arr);
      return this.Arr;
    },
  },
};
</script>

<style scoped>
.links:hover {
  color: green;
  cursor: pointer;
}
</style>
